import React, { useState, useEffect, useRef } from 'react';
import { currentDateFormat } from "../utils";
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../redux/loaderAction';
import Loader from '../components/loader/Loader';
import DHS from '../components/billingInfo/DHS';
import ClaimLyx from '../components/billingInfo/ClaimLyx';
import WAYSTAR from '../components/billingInfo/WayStar';
import { GET_ALL_PAYER, GET_BILLING_CONFIGURATION, CREATE_BILLING_CONFIGURATION } from '../constant';
import axios from 'axios';
import SaveButton from '../components/buttons/SaveButton';
import CancelButton from '../components/buttons/CancelButton';
import { useNavigate, Link } from "react-router-dom";
//import Swal from '../../node_modules/sweetalert2/dist/sweetalert2';
import Swal from '../messageBox/customSweetAlert';
import { billConfigurationValidation } from "../validation/Validation";

function BillingConfiguration() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((state) => state.loader.loading);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [isDHSOpen, setIsDHSOpen] = useState(false);
  const [isWAYSTAROpen, setIsWAYSTAROpen] = useState(false);
  const [isClaimLynxOpen, setIsClaimLynxOpen] = useState(false);
  const [payerList, setPayerList] = useState([]);
  const [dhsData, setDhsData] = useState({});
  const [wayStarData, setWayStarData] = useState([]);
  const [formData, setFormData] = useState({
    agency_tax_id: '',
    npi_umpi: '',
    texonamy: '',
    submitter_id: '',
    submitter_name: '',
    contact_person_name: '',
    contact_person_phone: '',
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const toggleDHSAccordion = () => {
    setIsDHSOpen(!isDHSOpen);
  };

  const toggleWAYSTARAccordion = () => {
    setIsWAYSTAROpen(!isWAYSTAROpen);
  };

  const toggleClaimLynxAccordion = () => {
    setIsClaimLynxOpen(!isClaimLynxOpen);
  };

  useEffect(() => {
    dispatch(setLoading(true));

    const loadUser = async () => {
      const response_3 = await axios.get(GET_ALL_PAYER);
      const response_4 = await axios.get(GET_BILLING_CONFIGURATION);
      //dispatch(setLoading(false));
      //console.log('response_4',response_4.data);
      setPayerList(response_3.data);
      setFormData({
        agency_tax_id: response_4.data.agency_tax_id,
        npi_umpi: response_4.data.npt_umpi,
        texonamy: response_4.data.texonamy,
        submitter_id: response_4.data.submitter_id,
        submitter_name: response_4.data.submitter_name,
        contact_person_name: response_4.data.contact_name,
        contact_person_phone: response_4.data.contact_phone,
        receiver_id: response_4.data.receiver_id,
        receiver_name: response_4.data.receiver_name,
        wayStarData: response_4.data.TransData,
        id: response_4.data?.id || '',
      });
      setWayStarData(response_4.data.TransData);
      dispatch(setLoading(false));
    }
    loadUser();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Prevent special characters from being entered/displayed.
    // Allowed: letters, numbers, spaces (e.g. "AB123", "SRS Web", "AYI 390")
    const stripSpecialChars = (v) => (v ?? "").toString().replace(/[^A-Za-z0-9 ]/g, "");
    const digitsOnly = (v) => (v ?? "").toString().replace(/\D/g, "");

    let nextValue = value;
    if (name === "contact_person_phone") {
      // Phone: keep digits only (removes all special characters like +, -, (), spaces)
      nextValue = digitsOnly(value);
    } else {
      nextValue = stripSpecialChars(value);
    }

    // Works for uncontrolled inputs using defaultValue as well (also handles paste).
    if (e.target.value !== nextValue) {
      e.target.value = nextValue;
    }

    setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
    setFormData((prevData) => ({
      ...prevData,
      [name]: nextValue,
    }));
  };
  const handleDhsDataChange = (data) => {
    setDhsData(data);
  };

  const handleWayStarDataChange = (data) => {
    setWayStarData(data);
  };
  // {console.log('wayStarData',wayStarData)}
  const handleSubmit = async (e) => {

    e.preventDefault();

    const allData = {
      ...formData,
      ...(dhsData && Object.keys(dhsData).length ? dhsData : {}),
      dhsData,
      wayStarData,
    };
    const isValid = billConfigurationValidation(allData);
    setErrors(isValid);
    if (Object.keys(isValid).length === 0) {
      try {
        setIsSubmitting(true);
        dispatch(setLoading(true));
        const response = await axios.post(CREATE_BILLING_CONFIGURATION, allData);
        console.log(response.data);
        if (response.data.status === '200') {
          dispatch(setLoading(false));
          setIsSubmitting(false);
          Swal.fire({
            title: 'Success!',
            text: response.data.message,
            icon: 'success',
            confirmButtonText: 'OK',
            allowOutsideClick: false
          });
          // navigate('/home/billing/list', { replace: true });

        } else {
          dispatch(setLoading(false));
          setIsSubmitting(false);
          Swal.fire({
            title: 'Error!',
            text: response.data.message,
            icon: 'Error',
            confirmButtonText: 'OK',
            allowOutsideClick: false
          });
          //alert('Billing information updated successfully');
        }

      } catch (error) {
        dispatch(setLoading(false));
        setIsSubmitting(false);
        console.error('Error updating billing information:', error);
        alert('Failed to update billing information');
      }
    }
  };

  return (
    <><div className="tab-pane fade active show" id="add-passenger" role="tabpanel" aria-labelledby="home-tab">
      <section>
        <div className='d-flex justify-content-between form-container'>
          <div>
            <h2 className="fs-5 font-weight-600"> BillingConfiguration</h2>
          </div>
          <div>
            <span>{currentDateFormat(currentDate)}</span>
          </div>
        </div>
      </section>
      <section>
        <div className='bg-white  px-5 py-4'>
          {/* <div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-items">
              <div>
                <label className='require-field'>Agency Name</label>
                <input type="text"
                  className="form-control"
                  autoComplete='off'
                  id="preferred_name"
                  {...register('agency_name', {
                    required: {
                      value: true,
                      message: 'Agency Name is required'
                    }
                  })} />
                <p className='errors'>{errors && errors.agency_name?.message}</p>
              </div>

              <div>
                <label className='require-field'>Address</label>
                <input type="text"
                  className="form-control"
                  autoComplete='off'
                  id="address_line_one"
                  {...register('address_1', {
                    required: {
                      value: true,
                      message: 'Address is required'
                    }
                  })} />
                <p className='errors'>{errors && errors.address_1?.message}</p>
              </div>

              <div>
                <label className='require-field'>City</label>
                <input type="text"
                  className="form-control"
                  autoComplete='off'
                  id="city"
                  {...register('city', {
                    required: {
                      value: true,
                      message: 'City is required'
                    }
                  })} />
                <p className='errors'>{errors && errors.city?.message}</p>
              </div>
              <div>
                <label className='require-field'>State</label>
                <select className="form-select" aria-label="Default select example" id='state' {...register("state")}>
                  <option value="">Select</option>
                  {stateData.map((state, index) => (
                    <option key={index} value={state.state_id}>{state.state_name}</option>
                  ))}
                </select>
              </div>


              <div>
                <label className='require-field'>Zip</label>
                <input type="text"
                  className="form-control"
                  autoComplete='off'
                  id="zip" {...register('zip', {
                    required: {
                      value: true,
                      message: 'Zip is required'
                    }
                  })}
                  onChange={(event) => {
                    const value = event.target.value;
                    event.target.value = value.replace(/[^0-9]/g, '').substring(0, 5);
                  } } />
                <p className='errors'>{errors && errors.zip?.message}</p>
              </div>
              <div className="form-item">
                <label className='require-field'>Email Address</label>
                <input type="text"
                  className="form-control"
                  autoComplete='off'
                  id="email_address"
                  {...register('email', {
                    required: 'Email is required',
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: 'Invalid email'
                    }
                  })} />
                <p className='errors'>{errors && errors.email?.message}</p>
              </div>
              <div>
                <label className='require-field'>Phone</label>
                <input type="text"
                  className="form-control"
                  autoComplete='off'
                  id="agency_phone"
                  {...register('agency_phone', {
                    required: {
                      value: true,
                      message: 'Address is required'
                    }
                  })} />
                <p className='errors'>{errors && errors.address_1?.message}</p>
              </div>
              <div className="form-group col-sm-4 item">
                <label className='require-field'>Company Id</label>
                <input type="text"
                  className="form-control"
                  ref={inputRef}
                  value={randomNumber}
                  id="agency_id" {...register('agency_id', { defaultValue: randomNumber })} disabled={true} />
              </div>

            </div>
            <div className="my-4">
              <p className='sub-title'>User Details</p>
              <div className="form-item">
                <ConfirmPassword register={register} getValues={getValues} errors={errors} isEditMode='1' />
              </div>

            </div>


            



            <div className='footer-content'>
              <SaveButton type='submit' buttonTitle={'UPDATE AGENCY'} />
              <CancelButton cancelHandler={() => navigate('/home/agency/list', { replace: true })} />
            </div>

          </form>
          <DevTool control={control} />
        </div> */}
          <form onSubmit={handleSubmit}>
            <div >
              <div className="row">
                <div className="col-lg-4 col-md-4 mb-4">
                  <div>
                    <label className='require-field'>Agency Tax Id</label>
                    <input type="text"
                      className="form-control"
                      autoComplete='off'
                      id="agency_tax_id"
                      name="agency_tax_id"
                      defaultValue={formData.agency_tax_id}
                      onChange={handleInputChange}
                    />
                  </div>
                  {errors.agency_tax_id && <span className='errors'>{errors.agency_tax_id}</span>}
                </div>
                <div className="col-lg-4 col-md-4 mb-4">
                  <div>
                    <label className='require-field'>NPI/UMPI</label>
                    <input
                      type="text"
                      className="form-control"
                      autoComplete='off'
                      id="npi_umpi"
                      defaultValue={formData.npi_umpi}
                      onChange={handleInputChange}
                      name="npi_umpi" />
                  </div>
                  {errors.npi_umpi && <span className='errors'>{errors.npi_umpi}</span>}
                </div>
                <div className="col-lg-4 col-md-4 mb-4">
                  <div>
                    <label className='require-field'>Taxonamy</label>
                    <input
                      type="text"
                      className="form-control"
                      autoComplete='off'
                      id="texonamy"
                      defaultValue={formData.texonamy}
                      onChange={handleInputChange}
                      name="texonamy" />
                  </div>
                  {errors.texonamy && <span className='errors'>{errors.texonamy}</span>}

                </div>
                <div className="col-lg-6 col-md-6 mb-4">
                  <div>
                    <label className='require-field'>Submitter Id</label>
                    <input
                      type="text"
                      className="form-control"
                      autoComplete='off'
                      id="submitter_id"
                      value='A287103500'
                      onChange={handleInputChange}
                      name="submitter_id"
                      readOnly
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 mb-4">
                  <div>
                    <label className='require-field'>Submitter Name</label>
                    <input
                      type="text"
                      className="form-control"
                      autoComplete='off'
                      value='SRS Web Solutions Inc'
                      onChange={handleInputChange}
                      id="submitter_name"
                      name="submitter_name"
                      readOnly
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-6 mb-4">
                  <div>
                    <label className='require-field'>Contact Name</label>
                    <input
                      type="text"
                      className="form-control"
                      autoComplete='off'
                      id="contact_person_name"
                      defaultValue={formData.contact_person_name}
                      onChange={handleInputChange}
                      name="contact_person_name" />
                  </div>
                  {errors.contact_person_name && <span className='errors'>{errors.contact_person_name}</span>}
                </div>
                <div className="col-md-6 col-lg-6 mb-4">
                  <div>
                    <label className='require-field'>Contact Phone</label>
                    <input
                      type="text"
                      className="form-control"
                      autoComplete='off'
                      defaultValue={formData.contact_person_phone}
                      id="contact_person_phone"
                      onChange={handleInputChange}
                      name="contact_person_phone" />
                  </div>
                  {errors.contact_person_phone && <span className='errors'>{errors.contact_person_phone}</span>}
                </div>
              </div>

            </div>
            <div className="accordion">
              <p className='sub-title'>Billing Provider Information</p>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button" type="button" onClick={toggleDHSAccordion}>
                    Account Information - DHS
                  </button>
                </h2>
                {isDHSOpen && (
                  <div className="accordion-collapse collapse show">
                    <div className="accordion-body">
                      <DHS
                        receiverId={formData.receiver_id}
                        receiverName={formData.receiver_name}
                        onDataChange={handleDhsDataChange}
                        errors={errors}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button" type="button" onClick={toggleWAYSTARAccordion}>
                    Account Information - WAYSTAR
                  </button>
                </h2>
                {isWAYSTAROpen && (
                  <div className="accordion-collapse collapse show">
                    <div className="accordion-body">
                      <WAYSTAR
                        payerList={payerList}
                        wayStarDetails={formData.wayStarData}
                        onDataChange={handleWayStarDataChange}
                      />
                    </div>
                  </div>
                )}
              </div>
              {/* <div className="accordion-item">
              <h2 className="accordion-header">
                  <button className="accordion-button" type="button" onClick={toggleClaimLynxAccordion}>
                      Account Information - ClaimLynx
                  </button>
              </h2>
              {isClaimLynxOpen && (
                  <div className="accordion-collapse collapse show">
                      <div className="accordion-body">
                          <label htmlFor="account-info-claimlynx">Account Information:</label>
                          <input type="text" id="account-info-claimlynx" className="form-control" />
                      </div>
                  </div>
              )}
          </div> */}
            </div>
            <div className='footer-content'>
              <SaveButton
                type='submit'
                buttonTitle='UPDATE BILLING INFO'
                loading={isSubmitting}
                loadingText='UPDATING...'
              />
              <CancelButton cancelHandler={() => navigate('/home/dashboard', { replace: true })} />
            </div>
          </form>
        </div>
      </section>
    </div>
      <div>
        {loading && <Loader />}
      </div></>

  )
}

export default BillingConfiguration